const areaList = [
  {
    text: "安徽",
    id: 1,
    children: [
      { text: "安庆", id: 32 },
      { text: "蚌埠", id: 33 },
      { text: "亳州", id: 48 },
      { text: "池州", id: 35 },
      { text: "滁州", id: 36 },
      { text: "阜阳", id: 37 },
      { text: "合肥", id: 38 },
      { text: "淮北", id: 39 },
      { text: "淮南", id: 40 },
      { text: "黄山", id: 41 },
      { text: "六安", id: 42 },
      { text: "马鞍山", id: 43 },
      { text: "宿州", id: 44 },
      { text: "铜陵", id: 45 },
      { text: "芜湖", id: 46 },
      { text: "宣城", id: 47 },
    ],
  },
  {
    text: "北京",
    id: 2,
    children: [{ text: "北京", id: 126 }],
  },
  {
    text: "福建",
    id: 3,
    children: [
      { text: "福州", id: 130 },
      { text: "龙岩", id: 131 },
      { text: "南平", id: 132 },
      { text: "宁德", id: 133 },
      { text: "莆田", id: 134 },
      { text: "泉州", id: 135 },
      { text: "三明", id: 136 },
      { text: "厦门", id: 137 },
      { text: "漳州", id: 138 },
    ],
  },
  {
    text: "甘肃",
    id: 4,
    children: [
      { text: "白银", id: 207 },
      { text: "定西", id: 208 },
      { text: "甘南藏族自治州", id: 209 },
      { text: "嘉峪关", id: 210 },
      { text: "金昌", id: 211 },
      { text: "酒泉", id: 212 },
      { text: "兰州", id: 213 },
      { text: "临夏回族自治州", id: 214 },
      { text: "陇南", id: 215 },
      { text: "平凉", id: 216 },
      { text: "庆阳", id: 217 },
      { text: "天水", id: 218 },
      { text: "武威", id: 219 },
      { text: "张掖", id: 220 },
    ],
  },
  {
    text: "广东",
    id: 5,
    children: [
      { text: "潮州", id: 302 },
      { text: "东莞", id: 303 },
      { text: "佛山", id: 304 },
      { text: "广州", id: 305 },
      { text: "河源", id: 306 },
      { text: "惠州", id: 307 },
      { text: "江门", id: 308 },
      { text: "揭阳", id: 309 },
      { text: "茂名", id: 310 },
      { text: "梅州", id: 311 },
      { text: "清远", id: 312 },
      { text: "汕头", id: 313 },
      { text: "汕尾", id: 314 },
      { text: "韶关", id: 315 },
      { text: "深圳", id: 316 },
      { text: "阳江", id: 317 },
      { text: "云浮", id: 318 },
      { text: "湛江", id: 319 },
      { text: "肇庆", id: 320 },
      { text: "中山", id: 321 },
      { text: "珠海", id: 322 },
    ],
  },
  {
    text: "广西",
    id: 6,
    children: [
      { text: "百色", id: 415 },
      { text: "北海", id: 416 },
      { text: "崇左", id: 417 },
      { text: "防城港", id: 418 },
      { text: "桂林", id: 419 },
      { text: "贵港", id: 420 },
      { text: "河池", id: 421 },
      { text: "贺州", id: 422 },
      { text: "来宾", id: 423 },
      { text: "柳州", id: 424 },
      { text: "南宁", id: 425 },
      { text: "钦州", id: 426 },
      { text: "梧州", id: 427 },
      { text: "玉林", id: 428 },
    ],
  },
  {
    text: "贵州",
    id: 7,
    children: [
      { text: "安顺", id: 519 },
      { text: "毕节", id: 520 },
      { text: "贵阳", id: 521 },
      { text: "六盘水", id: 522 },
      { text: "黔东南苗族侗族自治州", id: 523 },
      { text: "黔南布依族苗族自治州", id: 524 },
      { text: "黔西南布依族苗族自治州", id: 525 },
      { text: "铜仁", id: 526 },
      { text: "遵义", id: 527 },
    ],
  },
  {
    text: "海南",
    id: 8,
    children: [
      { text: "白沙黎族自治县", id: 610 },
      { text: "保亭黎族苗族自治县", id: 611 },
      { text: "昌江黎族自治县", id: 612 },
      { text: "澄迈县", id: 613 },
      { text: "定安县", id: 614 },
      { text: "东方", id: 615 },
      { text: "海口", id: 616 },
      { text: "乐东黎族自治县", id: 617 },
      { text: "临高县", id: 618 },
      { text: "陵水黎族自治县", id: 619 },
      { text: "琼海", id: 620 },
      { text: "琼中黎族苗族自治县", id: 621 },
      { text: "三亚", id: 622 },
      { text: "屯昌县", id: 623 },
      { text: "万宁", id: 624 },
      { text: "文昌", id: 625 },
      { text: "五指山", id: 626 },
      { text: "儋州", id: 627 },
      { text: "三沙市", id: 3272 },
    ],
  },
  {
    text: "河北",
    id: 9,
    children: [
      { text: "保定", id: 646 },
      { text: "沧州", id: 647 },
      { text: "承德", id: 648 },
      { text: "邯郸", id: 649 },
      { text: "衡水", id: 650 },
      { text: "廊坊", id: 651 },
      { text: "秦皇岛", id: 652 },
      { text: "石家庄", id: 653 },
      { text: "唐山", id: 654 },
      { text: "邢台", id: 655 },
      { text: "张家口", id: 656 },
    ],
  },
  {
    text: "河南",
    id: 10,
    children: [
      { text: "安阳", id: 804 },
      { text: "鹤壁", id: 805 },
      { text: "济源", id: 806 },
      { text: "焦作", id: 807 },
      { text: "开封", id: 808 },
      { text: "洛阳", id: 809 },
      { text: "南阳", id: 810 },
      { text: "平顶山", id: 811 },
      { text: "三门峡", id: 812 },
      { text: "商丘", id: 813 },
      { text: "新乡", id: 814 },
      { text: "信阳", id: 815 },
      { text: "许昌", id: 816 },
      { text: "郑州", id: 817 },
      { text: "周口", id: 818 },
      { text: "驻马店", id: 819 },
      { text: "漯河", id: 820 },
      { text: "濮阳", id: 821 },
    ],
  },
  {
    text: "黑龙江",
    id: 11,
    children: [
      { text: "大庆", id: 950 },
      { text: "大兴安岭", id: 951 },
      { text: "哈尔滨", id: 952 },
      { text: "鹤岗", id: 953 },
      { text: "黑河", id: 954 },
      { text: "鸡西", id: 955 },
      { text: "佳木斯", id: 956 },
      { text: "牡丹江", id: 957 },
      { text: "七台河", id: 958 },
      { text: "齐齐哈尔", id: 959 },
      { text: "双鸭山", id: 960 },
      { text: "绥化", id: 961 },
      { text: "伊春", id: 962 },
    ],
  },
  {
    text: "湖北",
    id: 12,
    children: [
      { text: "鄂州", id: 1041 },
      { text: "恩施土家族苗族自治州", id: 1042 },
      { text: "黄冈", id: 1043 },
      { text: "黄石", id: 1044 },
      { text: "荆门", id: 1045 },
      { text: "荆州", id: 1046 },
      { text: "潜江", id: 1047 },
      { text: "神农架林区", id: 1048 },
      { text: "十堰", id: 1049 },
      { text: "随州", id: 1050 },
      { text: "天门", id: 1051 },
      { text: "武汉", id: 1052 },
      { text: "仙桃", id: 1053 },
      { text: "咸宁", id: 1054 },
      { text: "襄阳", id: 1055 },
      { text: "孝感", id: 1056 },
      { text: "宜昌", id: 1057 },
    ],
  },
  {
    text: "湖南",
    id: 13,
    children: [
      { text: "常德", id: 1134 },
      { text: "长沙", id: 1135 },
      { text: "郴州", id: 1136 },
      { text: "衡阳", id: 1137 },
      { text: "怀化", id: 1138 },
      { text: "娄底", id: 1139 },
      { text: "邵阳", id: 1140 },
      { text: "湘潭", id: 1141 },
      { text: "湘西土家族苗族自治州", id: 1142 },
      { text: "益阳", id: 1143 },
      { text: "永州", id: 1144 },
      { text: "岳阳", id: 1145 },
      { text: "张家界", id: 1146 },
      { text: "株洲", id: 1147 },
    ],
  },
  {
    text: "吉林",
    id: 14,
    children: [
      { text: "白城", id: 1249 },
      { text: "白山", id: 1250 },
      { text: "长春", id: 1251 },
      { text: "吉林", id: 1252 },
      { text: "辽源", id: 1253 },
      { text: "四平", id: 1254 },
      { text: "松原", id: 1255 },
      { text: "通化", id: 1256 },
      { text: "延边朝鲜族自治州", id: 1257 },
    ],
  },
  {
    text: "江苏",
    id: 15,
    children: [
      { text: "常州", id: 1307 },
      { text: "淮安", id: 1308 },
      { text: "连云港", id: 1309 },
      { text: "南京", id: 1310 },
      { text: "南通", id: 1311 },
      { text: "苏州", id: 1312 },
      { text: "宿迁", id: 1313 },
      { text: "泰州", id: 1314 },
      { text: "无锡", id: 1315 },
      { text: "徐州", id: 1316 },
      { text: "盐城", id: 1317 },
      { text: "扬州", id: 1318 },
      { text: "镇江", id: 1319 },
    ],
  },
  {
    text: "江西",
    id: 16,
    children: [
      { text: "抚州", id: 1387 },
      { text: "赣州", id: 1388 },
      { text: "吉安", id: 1389 },
      { text: "景德镇", id: 1390 },
      { text: "九江", id: 1391 },
      { text: "南昌", id: 1392 },
      { text: "萍乡", id: 1393 },
      { text: "上饶", id: 1394 },
      { text: "新余", id: 1395 },
      { text: "宜春", id: 1396 },
      { text: "鹰潭", id: 1397 },
    ],
  },
  {
    text: "辽宁",
    id: 17,
    children: [
      { text: "鞍山", id: 1489 },
      { text: "本溪", id: 1490 },
      { text: "朝阳", id: 1491 },
      { text: "大连", id: 1492 },
      { text: "丹东", id: 1493 },
      { text: "抚顺", id: 1494 },
      { text: "阜新", id: 1495 },
      { text: "葫芦岛", id: 1496 },
      { text: "锦州", id: 1497 },
      { text: "辽阳", id: 1498 },
      { text: "盘锦", id: 1499 },
      { text: "沈阳", id: 1500 },
      { text: "铁岭", id: 1501 },
      { text: "营口", id: 1502 },
    ],
  },
  {
    text: "内蒙古",
    id: 18,
    children: [
      { text: "阿拉善盟", id: 1561 },
      { text: "巴彦淖尔市", id: 1562 },
      { text: "包头", id: 1563 },
      { text: "赤峰", id: 1564 },
      { text: "鄂尔多斯", id: 1565 },
      { text: "呼和浩特", id: 1566 },
      { text: "呼伦贝尔", id: 1567 },
      { text: "通辽", id: 1568 },
      { text: "乌海", id: 1569 },
      { text: "乌兰察布", id: 1570 },
      { text: "锡林郭勒盟", id: 1571 },
      { text: "兴安盟", id: 1572 },
    ],
  },
  {
    text: "宁夏",
    id: 19,
    children: [
      { text: "固原", id: 1662 },
      { text: "石嘴山", id: 1663 },
      { text: "吴忠", id: 1664 },
      { text: "银川", id: 1665 },
      { text: "中卫", id: 1681 },
    ],
  },
  {
    text: "青海",
    id: 20,
    children: [
      { text: "果洛藏族自治州", id: 1686 },
      { text: "海北藏族自治州", id: 1687 },
      { text: "海东", id: 1688 },
      { text: "海南藏族自治州", id: 1689 },
      { text: "海西蒙古族藏族自治州", id: 1690 },
      { text: "黄南藏族自治州", id: 1691 },
      { text: "西宁", id: 1692 },
      { text: "玉树藏族自治州", id: 1693 },
    ],
  },
  {
    text: "山东",
    id: 21,
    children: [
      { text: "滨州", id: 1734 },
      { text: "德州", id: 1735 },
      { text: "东营", id: 1736 },
      { text: "菏泽", id: 1737 },
      { text: "济南", id: 1738 },
      { text: "济宁", id: 1739 },
      { text: "莱芜", id: 1740 },
      { text: "聊城", id: 1741 },
      { text: "临沂", id: 1742 },
      { text: "青岛", id: 1743 },
      { text: "日照", id: 1744 },
      { text: "泰安", id: 1745 },
      { text: "威海", id: 1746 },
      { text: "潍坊", id: 1747 },
      { text: "烟台", id: 1748 },
      { text: "枣庄", id: 1749 },
      { text: "淄博", id: 1750 },
    ],
  },
  {
    text: "山西",
    id: 22,
    children: [
      { text: "长治", id: 1859 },
      { text: "大同", id: 1860 },
      { text: "晋城", id: 1861 },
      { text: "晋中", id: 1862 },
      { text: "临汾", id: 1863 },
      { text: "吕梁", id: 1864 },
      { text: "朔州", id: 1865 },
      { text: "太原", id: 1866 },
      { text: "忻州", id: 1867 },
      { text: "阳泉", id: 1868 },
      { text: "运城", id: 1869 },
    ],
  },
  {
    text: "陕西",
    id: 23,
    children: [
      { text: "安康", id: 1977 },
      { text: "宝鸡", id: 1978 },
      { text: "汉中", id: 1979 },
      { text: "商洛", id: 1980 },
      { text: "铜川", id: 1981 },
      { text: "渭南", id: 1982 },
      { text: "西安", id: 1983 },
      { text: "咸阳", id: 1984 },
      { text: "延安", id: 1985 },
      { text: "榆林", id: 1986 },
    ],
  },
  {
    text: "上海",
    id: 24,
    children: [{ text: "上海", id: 2081 }],
  },
  {
    text: "四川",
    id: 25,
    children: [
      { text: "阿坝藏族羌族自治州", id: 2085 },
      { text: "巴中", id: 2086 },
      { text: "成都", id: 2087 },
      { text: "达州", id: 2088 },
      { text: "德阳", id: 2089 },
      { text: "甘孜藏族自治州", id: 2090 },
      { text: "广安", id: 2091 },
      { text: "广元", id: 2092 },
      { text: "乐山", id: 2093 },
      { text: "凉山彝族自治州", id: 2094 },
      { text: "眉山", id: 2095 },
      { text: "绵阳", id: 2096 },
      { text: "南充", id: 2097 },
      { text: "内江", id: 2098 },
      { text: "攀枝花", id: 2099 },
      { text: "遂宁", id: 2100 },
      { text: "雅安", id: 2101 },
      { text: "宜宾", id: 2102 },
      { text: "资阳", id: 2103 },
      { text: "自贡", id: 2104 },
      { text: "泸州", id: 2105 },
    ],
  },
  {
    text: "天津",
    id: 26,
    children: [{ text: "天津", id: 2262 }],
  },
  {
    text: "西藏",
    id: 27,
    children: [
      { text: "阿里", id: 2268 },
      { text: "昌都", id: 2269 },
      { text: "拉萨", id: 2270 },
      { text: "林芝", id: 2271 },
      { text: "那曲", id: 2272 },
      { text: "日喀则", id: 2273 },
      { text: "山南", id: 2274 },
    ],
  },
  {
    text: "新疆",
    id: 28,
    children: [
      { text: "阿克苏", id: 2348 },
      { text: "阿拉尔", id: 2349 },
      { text: "巴音郭楞蒙古自治州", id: 2350 },
      { text: "博尔塔拉蒙古自治州", id: 2351 },
      { text: "昌吉回族自治州", id: 2352 },
      { text: "哈密", id: 2353 },
      { text: "和田", id: 2354 },
      { text: "喀什", id: 2355 },
      { text: "克拉玛依", id: 2356 },
      { text: "克孜勒苏柯尔克孜自治州", id: 2357 },
      { text: "石河子", id: 2358 },
      { text: "图木舒克", id: 2359 },
      { text: "吐鲁番", id: 2360 },
      { text: "乌鲁木齐", id: 2361 },
      { text: "五家渠", id: 2362 },
      { text: "伊犁哈萨克自治州", id: 2363 },
      { text: "可克达拉市", id: 3135 },
      { text: "昆玉市", id: 3136 },
      { text: "塔城地区", id: 3547 },
      { text: "铁门关市", id: 3548 },
      { text: "双河市", id: 3549 },
      { text: "阿勒泰地区", id: 3550 },
      { text: "北屯市", id: 3551 },
    ],
  },
  {
    text: "云南",
    id: 29,
    children: [
      { text: "保山", id: 2454 },
      { text: "楚雄彝族自治州", id: 2455 },
      { text: "大理白族自治州", id: 2456 },
      { text: "德宏傣族景颇族自治州", id: 2457 },
      { text: "迪庆藏族自治州", id: 2458 },
      { text: "红河哈尼族彝族自治州", id: 2459 },
      { text: "昆明", id: 2460 },
      { text: "丽江", id: 2461 },
      { text: "临沧", id: 2462 },
      { text: "怒江傈僳族自治州", id: 2463 },
      { text: "曲靖", id: 2464 },
      { text: "普洱市", id: 2465 },
      { text: "文山壮族苗族自治州", id: 2466 },
      { text: "西双版纳傣族自治州", id: 2467 },
      { text: "玉溪", id: 2468 },
      { text: "昭通", id: 2469 },
    ],
  },
  {
    text: "浙江",
    id: 30,
    children: [
      { text: "杭州", id: 2595 },
      { text: "湖州", id: 2596 },
      { text: "嘉兴", id: 2597 },
      { text: "金华", id: 2598 },
      { text: "丽水", id: 2599 },
      { text: "宁波", id: 2600 },
      { text: "绍兴", id: 2601 },
      { text: "台州", id: 2602 },
      { text: "温州", id: 2603 },
      { text: "舟山", id: 2604 },
      { text: "衢州", id: 2605 },
    ],
  },
  {
    text: "重庆",
    id: 31,
    children: [{ text: "重庆", id: 2675 }],
  },
  {
    text: "香港",
    id: 3557,
    children: [{ text: "香港特别行政区", id: 3150 }],
  },
  {
    text: "澳门",
    id: 3558,
    children: [{ text: "澳门特别行政区", id: 3308 }],
  },
  {
    text: "台湾",
    id: 3559,
    children: [{ text: "台湾省", id: 3532 }],
  },
];
export function getAreaJson() {
  // 为了解决引用时不影响源数据，故转义两次，约等于深拷贝
  return JSON.parse(JSON.stringify(areaList));
}
